import { render, staticRenderFns } from "./UsersClear.vue?vue&type=template&id=c125404c&scoped=true"
import script from "./UsersClear.vue?vue&type=script&lang=js"
export * from "./UsersClear.vue?vue&type=script&lang=js"
import style0 from "./UsersClear.vue?vue&type=style&index=0&id=c125404c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c125404c",
  null
  
)

export default component.exports